import styled from 'styled-components';
export const CountdownStyles = styled('div')`
  background-color: white;
  padding: 1.5rem 1rem 1rem;
  border-radius: 16px;
  margin-bottom: 1rem;
  border: 1px solid ${({ theme }) => theme.neutrals['200']};

  .title {
    text-align: center;
  }

  .inner {
    color: ${({ theme }) => theme.colors.secondary};
    display: flex;
    justify-content: center;
    padding: 0.5rem;
  }

  .segment {
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
  }

  .value {
    font-size: 3rem;
    font-weight: 900;
  }

  .divider {
    padding: 0 1.5rem;
  }

  .label {
    font-size: 1rem;
  }
`;
